export const PRODUCT_UNIT_TABLE = "productUnits"
// Indexed: id (PK), companyId, productId — recap surfaces filter by
// productId first when looking up the per-unit weight. unitId is also
// indexed for the (rare) "all products for this unit" lookup.
export const PRODUCT_UNIT_TABLE_SCHEMA =
  "id, companyId, productId, unitId, syncId, [companyId+productId]"
